export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/notifications/store/state.js